import React from 'react'
import { Upload as AntUpload } from 'antd'
import { DraggerProps as AntDraggerProps } from 'antd/lib/upload'
import cl from 'classnames'

import styles from './styles.module.scss'

const { Dragger: AntDragger } = AntUpload

type DraggerProps = AntDraggerProps & {
	className?: string
	hasError?: boolean
	hideDropZone?: boolean
}

const Dragger = React.forwardRef((props: DraggerProps, ref) => {
	const { className, hasError, hideDropZone = false } = props
	return (
		<AntDragger
			{...props}
			className={cl(
				styles.basicDragger,
				className,
				{ [styles.error]: hasError },
				{ [styles.hideDropZone]: hideDropZone }
			)}
			// @ts-ignore
			ref={ref}
		/>
	)
})

export default Dragger
